import React, { Component } from "react";
//import info from "./info";
import info from "./info.svg";

class AboutAppBtn extends Component {
  render() {
    const { abouttoggle } = this.props;
    return (
      <div className="info-Holder">
        <span className="from-label">ABOUT</span>
        <a href="#">
          <img src={info} alt="logo" onClick={abouttoggle} />
        </a>
      </div>
    );
  }
}

export default AboutAppBtn;
